module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"search-criteria":"検索条件","search-hit":"<span class=\u0027text-3xl font-bold text-secondary\u0027>{count}</span><span class=\u0027text-sm mt-1 ml-1 font-bold\u0027>件がヒットします</span>","no-hit":"該当する倉庫がありません","search-by-condition":"条件を変更して検索","prefectures":"都道府県","area":"エリア","trucksize-available":"対応可能なトラックサイズ","close":"閉じる","all":"全て"}}')
  delete Component.options._Ctor
}
